import React, { useCallback } from 'react';
import { ModalBody } from 'reactstrap';
import { VbzModal, VbzListOptions, VbzButton, IOption } from '@smiles/voebiz-ui-kit';
import { useTranslation } from 'react-i18next';
import logoHeaderMobileVoebiz from '../../assets/voebiz-logo-header-mobile.svg';

export interface IModalDefaultOptionList {
  id?: string;
  titleId?: string;
  btnPrimaryId?: string;
  btnSecondaryId?: string;
  isOpen: boolean;
  translate?: string;
  isInputValid?: boolean;
  hidePrimaryButton?: boolean;
  hideSecondaryButton?: boolean;
  list?: Array<IOption>;
  onClose?: () => void;
  onFinish?: (e: React.MouseEvent<Element, MouseEvent>) => void;
  onSecondary?: () => void;
  toggle?: () => void;
}

const ModalDefaultOptionList: React.FC<IModalDefaultOptionList> = ({
  id,
  titleId,
  btnPrimaryId,
  btnSecondaryId,
  isOpen,
  translate = '',
  isInputValid = true,
  hidePrimaryButton = false,
  hideSecondaryButton = false,
  list = [],
  onClose,
  onFinish,
  onSecondary,
  toggle,
}) => {
  const { t } = useTranslation(translate);

  const renderMessage = useCallback(() => {
    const data = t('message', { returnObjects: true });
    if (Array.isArray(data)) {
      return (
        <>
          {data.map((msg) => (
            <p key={msg}>msg</p>
          ))}
        </>
      );
    }
    return <p>{t('message')}</p>;
  }, [t]);

  return (
    <VbzModal id={id} isOpen={isOpen} onClosed={onClose} type="right" className="vbz-login-common" toggle={toggle}>
      <ModalBody>
        <span className="default-modal-logo hide-desktop-modal">
          <img src={logoHeaderMobileVoebiz} alt="VoeBiz Logo" />
        </span>
        <h3 className="modal-default-message-title "id={titleId}>{t('title')}</h3>
        {renderMessage()}
        <VbzListOptions list={list} />
        {!hidePrimaryButton && (
          <VbzButton id={btnPrimaryId} text={t('btn_primary')} disabled={!isInputValid} onClick={onFinish} />
        )}
        {!hideSecondaryButton && (
          <p id={btnSecondaryId} className="btn_hyperlink">
            {t('btn_secondary_prefix')}
            <a className="vbz-login-common-link" href="/atendimento" onClick={onSecondary}>
              {t('btn_secondary')}
            </a>
            {t('btn_secondary_suffix')}
          </p>
        )}
      </ModalBody>
    </VbzModal>
  );
};

export default ModalDefaultOptionList;
